export const RICH_TEXT_COMPONENTS = {
    p: <p />,
    br: <br />,
    ul: <ul />,
    ol: <ol />,
    li: <li />,
    b: <b />,
    strong: <strong />,
    i: <i />,
    em: <em />,
};
